export { default } from './ButtonRainbow';
